import React from "react";
// import { useSelector } from "react-redux";
// import { Formik, FormikHelpers } from "formik";
// import * as yup from "yup";
import { makeStyles } from "@material-ui/styles";
// import Typography from "@material-ui/core/Typography";
// import Paper from "@material-ui/core/Paper";
// import Drawer from "@material-ui/core/Drawer";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControl from "@material-ui/core/FormControl";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormLabel from "@material-ui/core/FormLabel";
// import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
// import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
// import { getFormData } from "./helpers";
// import { Values } from "./types";
// const sendFeedback = async (values: Values, actions: FormikHelpers<Values>, handleClose: () => void, showDialog: (text: string) => void) => {
//     await sleep(3000);
//     const data = getFormData(values);
//     try {
//         await axios.post("/api/feedback/", data, {
//             headers: {
//                 "X-CSRFToken": await getCSRFToken(),
//             },
//         });
//         showDialog(`🎉 Спасибо за отзыв! 🎉`);
//         actions.resetForm();
//     } catch (err) {
//         showDialog("Извините, не удалось отправить отзыв, пожалуйста, поробуйте в другое время.");
//     }
//     actions.setSubmitting(false);
//     handleClose();
// };
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: "15px 0",
    },
    paper: {
        width: "450px",
        height: "100%",
        padding: "15px 25px",
        overflowY: "auto",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "90vw",
        },
    },
    submitButton: {
        marginBottom: "15px",
        minWidth: "180px",
    },
    dialogContent: {
        padding: "15px 25px 0 25px",
    },
    warning: {
        marginBottom: theme.spacing(2),
    },
}));
const FeedbackForm = (props) => {
    const { show, handleClose } = props;
    const classes = useStyles();
    // const isStudent = useSelector(student);
    // const isAuthenticated = useSelector(authenticated);
    // const [showDialog, setShow] = React.useState<boolean>(true);
    // const [dialog, setDialog] = React.useState<string>("");
    // const handleDialogClose = React.useCallback(() => setShow(false), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: show, onClose: handleClose },
            React.createElement(DialogContent, { className: classes.dialogContent },
                React.createElement(DialogContentText, { color: "textPrimary" },
                    "\u0421\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u043E\u0439 Nomotex \u043C\u043E\u0436\u043D\u043E \u043F\u043E \u043F\u043E\u0447\u0442\u0435 ",
                    React.createElement("a", { href: "mailto:adm.nomotex@yandex.ru" }, "adm.nomotex@yandex.ru")),
                React.createElement(DialogContentText, null, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043D\u0435 \u0437\u0430\u0431\u0443\u0434\u044C\u0442\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u044C\u0441\u044F \u0438 \u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u043E \u043E\u043F\u0438\u0441\u0430\u0442\u044C \u0432\u0430\u0448\u0443 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443.")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: handleClose, variant: "outlined", color: "primary" }, "OK")))));
};
// const FeedbackForm = (props: { show: boolean; handleClose(): void }) => {
//     const { show, handleClose } = props;
//     const classes = useStyles();
//     const isStudent = useSelector(student);
//     const isAuthenticated = useSelector(authenticated);
//     const [showDialog, setShow] = React.useState<boolean>(false);
//     const [dialog, setDialog] = React.useState<string>("");
//     const handleDialogClose = React.useCallback(() => setShow(false), []);
//     return (
//         <>
//             <Formik<Values>
//                 initialValues={{
//                     type: "enhancement",
//                     title: "",
//                     description: "",
//                     email: "",
//                     files: [],
//                 }}
//                 validationSchema={yup.object().shape({
//                     type: yup.mixed().oneOf(["enhancement", "help", "bug"]),
//                     title: yup.string().required(),
//                     description: yup.string().required(),
//                     email: yup.string().email(),
//                 })}
//                 onSubmit={(values, actions) =>
//                     sendFeedback(values, actions, handleClose, (content) => {
//                         setShow(true);
//                         setDialog(content);
//                     })
//                 }
//                 validateOnMount
//             >
//                 {({ values, touched, errors, handleChange, handleSubmit, handleBlur, setFieldValue, isSubmitting, isValid }) => {
//                     return (
//                         <Drawer open={show} onClose={handleClose} variant="temporary" anchor="right">
//                             <Paper className={classes.paper}>
//                                 <FormControl fullWidth className={classes.formControl}>
//                                     <FormLabel required>Я хочу...</FormLabel>
//                                     <RadioGroup value={values.type} name="type" onChange={handleChange} onBlur={handleBlur}>
//                                         <FormControlLabel value="enhancement" control={<Radio />} label="Предложить улучшение" />
//                                         <FormControlLabel value="help" control={<Radio />} label="Получить помощь" />
//                                         <FormControlLabel value="bug" control={<Radio />} label="Сообщить об ошибке" />
//                                     </RadioGroup>
//                                 </FormControl>
//                                 <FormControl fullWidth className={classes.formControl}>
//                                     <FormLabel required error={Boolean(touched.title && errors.title)}>
//                                         Заголовок
//                                     </FormLabel>
//                                     <Input
//                                         required
//                                         name="title"
//                                         value={values.title}
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         error={Boolean(touched.title && errors.title)}
//                                     />
//                                 </FormControl>
//                                 <FormControl fullWidth className={classes.formControl}>
//                                     <FormLabel required error={Boolean(touched.description && errors.description)}>
//                                         Описание
//                                     </FormLabel>
//                                     <Input
//                                         required
//                                         name="description"
//                                         multiline
//                                         fullWidth
//                                         value={values.description}
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         rows={5}
//                                         placeholder="Введите сообщение"
//                                         error={Boolean(touched.description && errors.description)}
//                                     />
//                                 </FormControl>
//                                 <FormControl fullWidth className={classes.formControl}>
//                                     <FormLabel error={Boolean(touched.email && errors.email)}>
//                                         Если вы хотите, чтобы мы с Вами связались, укажите e-mail
//                                     </FormLabel>
//                                     <Input
//                                         name="email"
//                                         value={values.email}
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         error={Boolean(touched.email && errors.email)}
//                                     />
//                                 </FormControl>
//                                 <FormControl fullWidth className={classes.formControl}>
//                                     <FormLabel>При необходимости прикрепите файлы</FormLabel>
//                                     <FileUploader<Values> name="files" files={values.files} setFieldValue={setFieldValue} />
//                                 </FormControl>
//                                 {isStudent && isAuthenticated && (
//                                     <Typography className={classes.warning} variant="body2">
//                                         Обратите, пожалуйста, внимание на{" "}
//                                         <Link href="/faq/support/" onClick={() => handleClose()}>
//                                             правила обращения в техподдержку
//                                         </Link>
//                                     </Typography>
//                                 )}
//                                 <FormControl>
//                                     <Button
//                                         size="medium"
//                                         variant="contained"
//                                         color="primary"
//                                         disabled={isSubmitting || !isValid}
//                                         onClick={() => handleSubmit()}
//                                         className={classes.submitButton}
//                                     >
//                                         {isSubmitting ? <CircularProgress size={30} /> : "Отправить отзыв"}
//                                     </Button>
//                                 </FormControl>
//                             </Paper>
//                         </Drawer>
//                     );
//                 }}
//             </Formik>
//             <Dialog open={showDialog} onClose={handleDialogClose}>
//                 <DialogContent className={classes.dialogContent}>
//                     <DialogContentText color="textPrimary">{dialog}</DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleDialogClose} variant="outlined" color="primary">
//                         OK
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </>
//     );
// };
export default FeedbackForm;
